import React, { useMemo, useContext } from 'react';
import classnames from 'classnames';
import style from '../../grid-page.module.less';
import { FormattedMessage } from 'react-intl';
import PresetGroupGrid from './grid';
import PresetGroupsContextProvider, { PresetGroupsContext } from './context';
import { PagingContextProvider } from '../../../contexts/paging-context';
import PagingControlWrapper from '../PagingControlWrapper';
import { GridHeaderWithOverflow } from '../../../components/grid-header/grid-header-with-overflow';
import { AddPresetGroupButton } from './add-preset-group-button';
import messages from './messages';
import { UserSettings } from '../../../enums/user-settings/user-settings';
import { useUserSetting } from '../../../hooks/use-user-setting';
import { PAGE_SIZE_250 } from '../../../services/pagination-service';

const label = <FormattedMessage {...messages.presetGroupGridLabel} />;
const headerId = 'presetGroupGridHeader';
const view = {
  id: headerId,
  buttons: [<AddPresetGroupButton key={headerId} />],
  label,
};

const PresetGroupsPage = () => {
  const { totalRecords } = useContext(PresetGroupsContext);
  return (
    <div className={style['main-content']}>
      <div className={style['grid-header']}>
        <GridHeaderWithOverflow ignoreCustomOverflow view={view} />
      </div>
      <div className={style['grid-content']}>
        <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
          <PresetGroupGrid />
          <div className={[style['paging-footer']]}>
            <PagingControlWrapper totalRecords={totalRecords} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => {
  const userSetting = useUserSetting(UserSettings.presetGroupsGridPageSize.settingName);
  const userPageSize = useMemo(() => parseInt(userSetting || PAGE_SIZE_250, 10), [userSetting]);
  return (
    <PagingContextProvider page={1} pageSize={userPageSize}>
      <PresetGroupsContextProvider>
        <PresetGroupsPage />
      </PresetGroupsContextProvider>
    </PagingContextProvider>
  );
};
